import { defineStore } from "pinia";
import api from "../api";

export type MarkerKind = "custom" | "camp" | "water" | "viewpoint" | "danger" | "parking" | "other";

export interface UserMarker {
  id: number;
  name: string;
  kind: MarkerKind;
  lat: number;
  lng: number;
  // false - метка скрыта на карте, но остаётся в списке «Мои метки» (хранится в БД).
  visible: boolean;
  created_at: string;
}

export interface UserMarkerDraft {
  name: string;
  kind: MarkerKind;
  lat: number;
  lng: number;
}

// Личные метки владельца («Своя метка», бэкенд - app/markers). Требуют входа:
// вызывающий (usePointTool) загружает список только для залогиненного и
// сбрасывает стор при выходе, чтобы метки прошлого пользователя не
// оставались в памяти.
export const useMyMarkersStore = defineStore("myMarkers", {
  state: () => ({
    items: [] as UserMarker[],
    loaded: false,
  }),
  actions: {
    async fetch(force = false) {
      if (this.loaded && !force) return;
      try {
        const res = await api.get<UserMarker[]>("/me/markers");
        this.items = res.data || [];
        this.loaded = true;
      } catch {
        // оставляем как есть - карта работает и без личных меток
      }
    },
    async create(draft: UserMarkerDraft): Promise<UserMarker | null> {
      try {
        const res = await api.post<UserMarker>("/me/markers", draft);
        this.items = [res.data, ...this.items];
        return res.data;
      } catch {
        return null;
      }
    },
    async update(id: number, patch: { name?: string; kind?: MarkerKind; visible?: boolean }): Promise<boolean> {
      try {
        const res = await api.patch<UserMarker>(`/me/markers/${id}`, patch);
        this.items = this.items.map((m) => (m.id === id ? res.data : m));
        return true;
      } catch {
        return false;
      }
    },
    async remove(id: number): Promise<boolean> {
      try {
        await api.delete(`/me/markers/${id}`);
        this.items = this.items.filter((m) => m.id !== id);
        return true;
      } catch {
        return false;
      }
    },
    clear() {
      this.items = [];
      this.loaded = false;
    },
  },
});
